import { ActionTextLinkCell } from "./ActionCellPrimitives";
import CalculatorIcon from "~/common/mui/icons/Calculator";

export const OpenCalcAction = ({ url, ...rest }: { url?: string }) => (
  <ActionTextLinkCell href={url} invisible={!url} target={"_blank"} {...rest}>
    <CalculatorIcon  />
  </ActionTextLinkCell>
);
